import { FormProvider, useForm } from 'react-hook-form';
import Text from '@components/common/text';
import SearchField from '@components/common/hookFormFields/searchField';
import ReviewList from './reviewList';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const PassReview = () => {
  const methods = useForm({
    defaultValues: {
      keyword: '',
      page: 0,
      size: 10,
      totalPages: 0,
      totalElements: 0,
    },
  });

  const { reset, getValues } = methods;

  const handleKeyword = (keyword?: string) => {
    reset({ ...getValues(), keyword });
  };

  return (
    <FormProvider {...methods}>
      <div className={cx('wrapper')}>
        <div className={cx('titleArea')}>
          <Text fontStyle={FontStyle.H4_B}>합격 후기 게시판</Text>
          <SearchField
            prefixName={'test'}
            width={280}
            height={48}
            placeholder="제목을 검색해 보세요."
            onEnter={handleKeyword}
            onBlur={handleKeyword}
            onClear={handleKeyword}
          />
        </div>

        <ReviewList />
      </div>
    </FormProvider>
  );
};

export default PassReview;
